import { render, staticRenderFns } from "./AddPackage.vue?vue&type=template&id=d4282526&scoped=true"
import script from "./AddPackage.vue?vue&type=script&lang=js"
export * from "./AddPackage.vue?vue&type=script&lang=js"
import style0 from "./AddPackage.vue?vue&type=style&index=0&id=d4282526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4282526",
  null
  
)

export default component.exports